// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D5362KDaoepd5s {
  max-width: 400px;
  height: 32px;
  margin-bottom: var(--ds-space-0, 0px);
  padding-right: var(--ds-space-150, 12px);
  padding-left: var(--ds-space-100, 8px);
  overflow: hidden;
  border: none;
  border-radius: var(--ds-border-radius-100, 3px);
  font-weight: var(--ds-font-weight-medium, 500);
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-highlighted);
  color: var(--dynamic-button-highlighted-text);
}
.D5362KDaoepd5s svg circle {
  stroke: var(--dynamic-icon);
}
.D5362KDaoepd5s:hover {
  background: var(--dynamic-button-highlighted-hovered);
  color: var(--dynamic-button-highlighted-text);
}
.D5362KDaoepd5s.pQpOrns1ytE4ie {
  background-color: var(--dynamic-button);
  color: var(--dynamic-text);
}
.D5362KDaoepd5s.pQpOrns1ytE4ie svg circle {
  stroke: var(--dynamic-icon);
}
.D5362KDaoepd5s.pQpOrns1ytE4ie:hover {
  background-color: var(--dynamic-button-hovered);
  color: var(--dynamic-text);
}
.D5362KDaoepd5s.pQpOrns1ytE4ie:hover svg circle {
  stroke: var(--dynamic-icon);
}
.kkXBQZy2tqBcdK {
  display: flex;
  align-items: center;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
.KVd2N75klrKX13 {
  margin-left: var(--ds-space-050, 4px);
}
@media print {
  .KVd2N75klrKX13 {
    color: var(--ds-text, #172b4d);
  }
}
.UegABlvv4vDG_3 {
  position: relative;
  top: 1px;
}
@media print {
  .UegABlvv4vDG_3 svg {
    color: var(--ds-text, #172b4d);
  }
}
.tXGecpx4QQzZEn {
  padding: var(--ds-space-050, 4px);
}
.fW4zJ0hJdD7OPW {
  overflow: visible;
}
.rTeJcC_hcOQqNP {
  margin-left: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var boardShareButton = `D5362KDaoepd5s`;
export var embedded = `pQpOrns1ytE4ie`;
export var flexButton = `kkXBQZy2tqBcdK`;
export var boardShareButtonText = `KVd2N75klrKX13`;
export var boardShareButtonIcon = `UegABlvv4vDG_3`;
export var personAddIconContainer = `tXGecpx4QQzZEn`;
export var inviteDialog = `fW4zJ0hJdD7OPW`;
export var accessRequestsBadgeContainer = `rTeJcC_hcOQqNP`;
export default ___CSS_LOADER_EXPORT___;
